import { api } from './pos-api';
import { readSettings } from './offline';
import { getActiveStore } from './scope';

// Always use the document's branch. Offline fallback must never borrow another store.
export async function loadReceiptSettings(storeId) {
  const store = storeId || getActiveStore();
  const cached = readSettings();
  const fallback = !store || cached.store_id === store ? cached : {};
  try {
    const {data} = await api.get('/settings', {timeout:5000, ...(store ? {headers:{'X-Store-Id':store}} : {})});
    return !store || data.store_id === store ? data : fallback;
  } catch { return fallback; }
}
